import React from 'react';
import ColorTag from './ColorTag';

interface ColorTagFinancialAdministratorProps {}

const ColorTagFinancialAdministrator: React.FC<ColorTagFinancialAdministratorProps> = props => {
  return <ColorTag className="ColorTagFinancialAdministrator" color="magenta" appearance="translucent">Financial Admin</ColorTag>
}

export default ColorTagFinancialAdministrator;